export default "__VITE_ASSET__J8P8t2yQ__"